import merge from 'lodash/merge';
import BN_Asam4AssessmentDimension from './BN_Asam4AssessmentDimension';
import BN_Asam4AssessmentMeasure from './BN_Asam4AssessmentMeasure';
import BN_Asam4LevelOfCareReviewCriteria from './BN_Asam4LevelOfCareReviewCriteria';

import DomainResource from './DomainResource';
import Reference from './types/Reference';

export default class BN_Asam4Assessment extends DomainResource {
    static _className = 'BN_Asam4Assessment';

    _objectStructure = {
        patient: Reference,
        encounter: Reference,
        episodeOfCare: Reference,
        questionnaireResponse: Reference,
        date: Date,
        author: Reference,
        type: String,
        dimension: [BN_Asam4AssessmentDimension],
        recommendedLevelOfCare: String,
        recommendedLevelOfCareRecoveryResidence: Boolean,
        recommendedLevelOfCareMedicalEvaluation: Boolean,
        recommendedLevelOfCareMoudContinuation: Boolean,
        recommendedLevelOfCareCoe: Boolean,
        levelOfCare: String,
        barrierToCare: String,
        preferences: String,
        readinessToChange: [String],
        measure: [BN_Asam4AssessmentMeasure],
        placement: String,
        placementRecoveryResidence: Boolean,
        placementMedicalEvaluation: Boolean,
        placementMoudContinuation: Boolean,
        placementCoe: Boolean,
        reason: String,
        reasonOther: String,
        consequence: [String],
        consequenceOther: String,
        consequenceDetail: String,
        levelOfCareReview: String,
        levelOfCareReviewCriteria: [BN_Asam4LevelOfCareReviewCriteria],
        levelOfCareReviewDetail: String,
        levelOfCareReviewNotes: String,
    };

    constructor(constructJson, className = 'BN_Asam4Assessment') {
        super(constructJson, className);
        this.createAndPopulateStructure(this._objectStructure, constructJson, this._objectDefaults);

        this.originalObjJson = this.toJSON();
    }

    toJSON() {
        return merge(super.toJSON(this), this.getJsonForStructure(this._objectStructure));
    }
}
